export const COMPANY = {
  SET_LOADING: 'SET_LOADING',
  SET_MODAL: 'SET_MODAL',
  GET_COMPANIES: 'GET_COMPANIES',
  GET_COMPANY: 'GET_COMPANY',
  EDIT_COMPANY: 'EDIT_COMPANY',
  GET_COMPANIES_SUCCESS: 'GET_COMPANIES_SUCCESS',
  GET_COMPANY_SUCCESS: 'GET_COMPANY_SUCCESS',
  GET_COMPANIES_FAIL: 'GET_COMPANIES_FAIL',
  GET_COMPANY_FAIL: 'GET_COMPANY_FAIL',
  CREATE_COMPANY: 'CREATE_COMPANY',
  RESET_COMPANY: 'RESET_COMPANY',

  GET_COMPANY_NOTIFICATIONS: 'GET_COMPANY_NOTIFICATIONS',
  GET_COMPANY_NOTIFICATIONS_SUCCESS: 'GET_COMPANY_NOTIFICATIONS_SUCCESS',
  GET_COMPANY_NOTIFICATIONS_FAIL: 'GET_COMPANY_NOTIFICATIONS_FAIL',

  PATCH_COMPANY_NOTIFICATIONS: 'PATCH_COMPANY_NOTIFICATIONS',

  GET_COMPANY_AVATARS: "GET_COMPANY_AVATARS",
  GET_COMPANY_AVATARS_SUCCESS: "GET_COMPANY_AVATARS_SUCCESS",
  GET_COMPANY_AVATARS_FAIL: "GET_COMPANY_AVATARS_FAIL",
};
